import type { BandSpace } from '@tunasong/schemas'

export const folderTemplate: BandSpace = {
  type: 'bandspace',
  name: 'Untitled',
}

export default folderTemplate
